require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-christopher-louie-lu.json") })
        }
      }, "path---member-christopher-louie-lu");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-christopher-louie-lu!./.cache/json/member-christopher-louie-lu.json
// module id = 395
// module chunks = 231608221292675